import {
  Image,
  Modal,
  ModalContent,
  Typography,
} from '@curology/ui-components-web/react';

import { IngredientsAccordion } from '@/components/product-selection/components/ProductIngredientsModal/components/IngredientsAccordion';

const BodyCleanseModal = ({
  open,
  onClose,
}: {
  open: boolean;
  onClose: () => void;
}) => {
  return (
    <Modal
      width={548}
      title={
        <Typography className="cur-mt-1 cur-grow" size="h1">
          Body Cleanse <sup>Rx</sup>
        </Typography>
      }
      open={open}
      onClose={onClose}
    >
      <ModalContent className="cur-bg-surface-neutral cur-p-4 cur-text-primary">
        <Image
          alt={'Body Cleanse Rx'}
          aspectRatio="3:2"
          src="https://images.ctfassets.net/8pzh4g8cs30t/7MD91xs7uC9NdKFYgD3um7/69c3b827d2d48773aac6ea06583152ed/body-cleanse-large.png"
        />
        <Typography className="cur-mt-4" size="h2">
          Body Cleanse<sup>Rx</sup>
        </Typography>
        <Typography className="cur-mt-4" weight="bold">
          Custom Acne Treatment Body Wash
        </Typography>
        <Typography className="cur-mt-4" size="h3">
          Why it&apos;s special
        </Typography>
        <Typography className="cur-mt-4">
          Body Cleanse<sup>Rx</sup> is a unique, prescription-powered treatment
          body wash—designed to help clear and prevent body acne with a renewing
          lather. Body Cleanse<sup>Rx</sup> is formulated by dermatologists to
          target common causes of body acne, while going deep into pores to wash
          away dead skin cells and excess oil.
        </Typography>
        <Typography className="cur-mt-4">
          It’s designed to be gentle on all skin types, including sensitive
          skin. Each wash leaves you feeling smooth and refreshed, without
          stripping skin. Add Body Cleanse<sup>Rx</sup> to your existing shower
          routine for a healthy, head-to-toe glow.
        </Typography>
        <Typography className="cur-mt-4" size="h3">
          How to use it
        </Typography>
        <Typography className="cur-mt-4">
          Apply Body Cleanse<sup>Rx</sup> while showering. Gently massage a thin
          layer onto the body breakout areas you wish to treat, including the
          chest, shoulders, and back. Leave on for up to 30 seconds before
          rinsing off.
        </Typography>
        <Typography className="cur-mt-4">
          Use up to two times daily. Work your way up to daily use when starting
          the treatment as dryness and irritation may occur.
        </Typography>
        <Typography className="cur-mt-4">
          Because this is a prescription product, always follow your licensed
          dermatology provider’s instructions for how best to use it with your
          unique skin.
        </Typography>
        <Typography className="cur-mt-4" size="h3">
          Active ingredients
        </Typography>
        <IngredientsAccordion
          body="Helps to fight acne-contributing bacteria on the skin"
          title="Sulfacetamide"
        />
        <IngredientsAccordion
          body="Soothes inflammation and helps keep bacteria and fungi in check"
          title="Zinc pyrithione"
        />
        <IngredientsAccordion
          body="Goes deep into pores to clear away dead skin cells and excess oil"
          title="Salicylic acid"
        />
        <Typography className="cur-mt-4" size="h3">
          Inactive ingredients
        </Typography>
        <Typography className="cur-mt-4">
          Water, Sodium Cocoyl Isethionate, Cocamidopropyl Hydroxysultaine,
          Acrylates Copolymer, Propanediol, Xylitylglucoside, Coconut Alcohol,
          Glycerin, Panthenol, Coco-Glucoside, Anhydroxylitol, Stearic Acid,
          1,2-Hexanediol, Citric Acid, Xylitol, PEG-150 Pentaerythrityl
          Tetrastearate, Stearyl Alcohol, Sodium Hydroxide, Caprylhydroxamic
          Acid, Xanthan Gum, Potassium Sorbate, Avena Sativa (Oat) Kernel
          Extract
        </Typography>
      </ModalContent>
    </Modal>
  );
};

export { BodyCleanseModal };
